import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'button', 'panel', 'header'];
var baseStyleContainer = {
  borderBottom: '1px',
  borderColor: 'grey.300',
  borderBottomLeftRadius: 'lg',
  borderBottomRightRadius: 'lg'
};
var baseStyleHeader = {
  fontSize: '1rem',
  fontWeight: 'bold',
  lineHeight: 'base',
  borderTop: '1px',
  borderLeft: '1px',
  borderRight: '1px',
  borderBottom: '1px',
  borderColor: 'grey.300',
  borderTopLeftRadius: 'lg',
  borderTopRightRadius: 'lg',
  borderBottomRightRadius: 'lg',
  borderBottomLeftRadius: 'lg',
  bg: 'grey.100',
  '&[data-open="false"]': {
    bg: 'white'
  },
  _focus: {
    boxShadow: 'outline'
  },
  _hover: {
    bg: 'blackAlpha.50'
  },
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed'
  },
  px: 6,
  py: 3
};
var baseStylePanel = {
  pt: 2,
  px: 4,
  pb: 5,
  borderLeft: '1px',
  borderRight: '1px',
  borderColor: 'grey.300',
  borderBottomRightRadius: 'lg',
  borderBottomLeftRadius: 'lg'
};
var baseStyleButton = {
  color: 'blue.600',
  ml: 4
};
var baseStyle = {
  container: baseStyleContainer,
  header: baseStyleHeader,
  button: baseStyleButton,
  panel: baseStylePanel
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});